<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p [innerHTML]="confirmMessage"></p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="dialogRef.close(true)">{{okButtonLabel}}</button>
  <button mat-raised-button *ngIf="showCancelButton" (click)="dialogRef.close(false)">{{cancelButtonLabel}}</button>
</div>
